var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isWeb)?_vm._t("web"):_vm._t("mobile",[_vm._v(" MMMM "),(_vm.isAndroid)?_vm._t("android"):_vm._e(),(_vm.isIos)?_vm._t("ios"):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }